module.exports = __webpack_public_path__ + "media/pristine-609.a2050abb.mp3";